import React, { useEffect } from 'react';
import { SiteSettings } from '../types';

interface AdSenseScriptProps {
    settings: SiteSettings;
    currentPath?: string;
}

const AdSenseScript: React.FC<AdSenseScriptProps> = ({ settings, currentPath }) => {
    useEffect(() => {
        if (!settings.enableAdSense || !settings.adSenseClientId) return;

        const loadAds = () => {
             // Tenta limpar os Auto Ads injetados na tela anterior para não duplicar visualmente
             document.querySelectorAll('.google-auto-placed').forEach(el => el.remove());
             
             // Remove o script do Adsense antigo
             const existingScript = document.querySelector('script[src*="adsbygoogle.js"]');
             if (existingScript) existingScript.remove();
             
             // Adiciona a tag script novamente para forçar um "novo scan" na página atualizada do React
             const script = document.createElement('script');
             script.src = `https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=${settings.adSenseClientId}`;
             script.async = true;
             script.crossOrigin = "anonymous";
             document.head.appendChild(script);
        };

        // Aguarda 500ms para garantir que o React renderizou o novo conteúdo (ex: de Home para Contato)
        const timer = setTimeout(loadAds, 500);
        
        return () => clearTimeout(timer);
    }, [settings.enableAdSense, settings.adSenseClientId, currentPath]);

    return null;
};

export default AdSenseScript;
